import React from "react";
import style from "./logCard.module.scss"
import toPersianNumber from "../../../helpers/actions/toPersianNumber";
import { Link } from "react-router-dom";
import toEnglishNumber from "../../../helpers/actions/toEnglishNumber"

const LogCard = (props) => {

    const determineType = typeName => {
        let res = 'کوچک'
        switch (typeName) {
            case 'small':
                res = 'کوچک'
                break;
            case 'medium':
                res = 'متوسط'
                break;
            case 'big':
                res = 'بزرگ'
                break;
        }
        return res
    }

    const calculateDate = (date, type) => {
        let current = ''
        if (type == 'date') {
            current = new Date(date).toLocaleDateString('fa-IR')
        } else {
            current = toPersianNumber(new Date(date).getHours()) + ':' + toPersianNumber(new Date(date).getMinutes())
        }
        return current;
    }

    return (
        <>
            <div className={style.wrapper} style={props.data.status == "false" ? { borderRadius: '8px 8px 0px 0px' } : { borderRadius: '8px' }}>
                <div className={props.data.status == true ? style.iconWrapperGreen : style.iconWrapperRed}>
                    <div className={style.icon}></div>
                </div>
                <div className={style.flexWrapper}>

                    <div className={style.listHeaderItem176}>
                        <a href={`https://seller.digikala.com/pwa/packages/${props.data.cargoNumber}`}>
                            {props.data.cargoNumber ? toPersianNumber(props.data.cargoNumber) : (props.data.error ? props.data.error : '')}
                        </a>
                    </div>
                    <div className={style.listHeaderItem120}>
                        <span>{props.data.createDate ? calculateDate(props.data.createDate, 'date') : '--'}</span>
                        {/* <span>{determineDate('hour', props.data.createPackageDate)}</span> */}
                    </div>
                    <div className={style.listHeaderItem120}>
                        <span>{props.channelList && props.channelList.length > 0 ? props.channelList[0].name : '--'}{props.channelList[0]._id == "66c7067044e53ffa53755c93" ? ' ۲ ' : ''}</span>
                    </div>
                    <div className={style.listHeaderItem132}>{props.data.warehouse && props.data.warehouse.name ? props.data.warehouse.name : '--'}</div>
                    <div className={style.listHeaderItem48}>{determineType(props.data.natureType)}</div>

                </div>
            </div>

            {props.data.status == 'false' ? props.data.error ? <div className={style.failStatus}>
                <span className={style.errorIcon}>n</span>
                <p className={style.errorMessage}>{props.data.error}</p>
            </div>
                :
                <div className={style.failStatus}>
                    <span className={style.errorIcon}>n</span>
                    <p className={style.errorMessage}>خطا در ساخت محموله</p>
                </div>
                :
                null
            }
        </>
    );
}

export default LogCard;
